import MenuLanding from 'views/profile/landing/MenuLanding.container';

export default MenuLanding;
